import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCertificateRegular = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 9.25H9C8.59 9.25 8.25 9.59 8.25 10C8.25 10.41 8.59 10.75 9 10.75H19C19.41 10.75 19.75 10.41 19.75 10C19.75 9.59 19.41 9.25 19 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 13.25C8.59 13.25 8.25 13.59 8.25 14C8.25 14.41 8.59 14.75 9 14.75H13C13.41 14.75 13.75 14.41 13.75 14C13.75 13.59 13.41 13.25 13 13.25H9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.47 18.4699L21 21.9399L19.53 20.4699C19.24 20.1799 18.76 20.1799 18.47 20.4699C18.18 20.7599 18.18 21.2399 18.47 21.5299L20.47 23.5299C20.62 23.6799 20.81 23.7499 21 23.7499C21.19 23.7499 21.38 23.6799 21.53 23.5299L25.53 19.5299C25.82 19.2399 25.82 18.7599 25.53 18.4699C25.24 18.1799 24.76 18.1799 24.47 18.4699Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 3.25H7C4.38 3.25 2.25 5.38 2.25 8V18C2.25 20.62 4.38 22.75 7 22.75H14.4497C15.2461 26.1814 18.3315 28.75 22 28.75C26.27 28.75 29.75 25.27 29.75 21C29.75 19.0074 28.9922 17.1869 27.75 15.8118V8C27.75 5.38 25.62 3.25 23 3.25ZM26.25 14.5238C25.0285 13.719 23.5675 13.25 22 13.25C17.73 13.25 14.25 16.73 14.25 21C14.25 21.0836 14.2513 21.167 14.254 21.25H7C5.21 21.25 3.75 19.79 3.75 18V8C3.75 6.21 5.21 4.75 7 4.75H23C24.79 4.75 26.25 6.21 26.25 8V14.5238ZM22 27.25C18.55 27.25 15.75 24.45 15.75 21C15.75 17.55 18.55 14.75 22 14.75C25.45 14.75 28.25 17.55 28.25 21C28.25 24.45 25.45 27.25 22 27.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgCertificateRegular;
